import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import moment from 'moment-timezone'

import VirtualVisitInverted from '@scoir/brand-icons/dist/VirtualVisitInverted'

import './UpcomingVisitPreview.scss'

const UpcomingVisitPreview = ({ item }) => {
  const startTime = moment.tz(item.StartTime, item.StartTimeZone)
  const focusTime = startTime.format('YYYYMMDD')
  return (
    <Link
      to={`${import.meta.env.BASE_URL}/recruit/visits/view/week?focus=${focusTime}`}
      key={item.Id}
      className="upcoming-visit-wrap"
    >
      <div className="upcoming-visit">
        <div className="visit-date">
          <p>{startTime.format('M/D')}</p>
          <p>{startTime.format('ddd')}</p>
        </div>
        <div className="visiting-highschool">
          <p
            className="highschool-name"
            key={item.HighSchoolId}
          >
            {item.HighSchoolName}
          </p>
          <p className="visit-time">
            <span>{startTime.format('h:mmA z')}</span>
            {item.Virtual && (
              <span>
                <VirtualVisitInverted />
              </span>
            )}
          </p>
        </div>
      </div>
    </Link>
  )
}

UpcomingVisitPreview.propTypes = {
  item: PropTypes.any.isRequired,
}

export default UpcomingVisitPreview
